type TruckColorShade = {
  primaryColor: string;
  shadow1: string;
  shadow2: string;
  shadow3: string;
  shadow4: string;
};

type TruckColorShadeValues = [string, string, string, string, string];

const truckColorShades: TruckColorShadeValues[] = [
  ["#001616", "#262626", "#1A1A1A", "#121212", "#0A0A0A"],
  ["#CF9202", "#a87402", "#7f5801", "#5a3e01", "#3a2800"],
  ["#8E9490", "#6f7471", "#555957", "#3d4040", "#262828"],
  ["#006C38", "#00562c", "#004021", "#002b16", "#00190d"],
  ["#8F0800", "#700600", "#550500", "#3b0300", "#240200"],
  ["#01346A", "#012a55", "#012040", "#00162c", "#000d1a"],
  ["#77198E", "#5f1472", "#471055", "#300a39", "#18051c"],
];

export const truckColorPalette = truckColorShades.reduce<Record<string, TruckColorShade>>(
  (palette, [primaryColor, shadow1, shadow2, shadow3, shadow4]) => ({
    ...palette,
    [primaryColor]: {
      primaryColor,
      shadow1,
      shadow2,
      shadow3,
      shadow4,
    },
  }),
  {}
);
